import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Delete Account</Typography>
      <p>If you no longer wish to use Smartix services then you can request
        account deletion here.
      </p>

      <p> Please ensure you have read the details before proceeding.</p>

      <p>You have limited time to cancel your account deletion before your account 
        is deleted and is non-recoverable.
      </p>

      <p>We can alternatively place your account into a suspended state where it is
        inaccessible. We can then re-enable your account at a later date. Please
        contact us if you would prefer this option.
      </p>
    </div>
  )
}

export default HelpText